"use client"

import { useEffect } from "react"
import { usePartnerLinksStore } from "@/lib/partner-links-store"
import { useAdStore } from "@/lib/ad-store"
import { ExternalLink } from "@/lib/icons"
import { cn } from "@/lib/utils"
import { useTranslations } from "next-intl"

export function PartnerLinksBar({ hideUI }: { hideUI: boolean }) {
  const t = useTranslations("partnerLinksBar")
  const { links, fetchLinks, trackClick } = usePartnerLinksStore()
  const showPartnerFooter = useAdStore((state) => state.showPartnerFooter)

  useEffect(() => {
    fetchLinks()
  }, [fetchLinks])

  if (!showPartnerFooter || links.length === 0 || hideUI) return null

  const handleClick = (link: (typeof links)[0]) => {
    trackClick(link.id)
    window.open(link.url, "_blank", "noopener,noreferrer")
  }

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-20 border-t border-border/30 bg-background/95 backdrop-blur-md shadow-lg">
      <div className="container mx-auto px-3 py-2">
        <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide">
          <span className="text-xs text-muted-foreground shrink-0 mr-1">{t("partners")}</span>
          {links.map((link) => (
            <button
              key={link.id}
              onClick={() => handleClick(link)}
              className={cn(
                "flex items-center gap-1.5 px-2.5 py-1 rounded-full",
                "bg-secondary/60 hover:bg-secondary/80",
                "border border-border/50 hover:border-border",
                "text-xs font-medium text-foreground/90 hover:text-foreground",
                "transition-all duration-200 shrink-0",
                "group",
              )}
              title={link.description}
            >
              {link.favicon_url && (
                <img
                  src={link.favicon_url || "/placeholder.svg"}
                  alt=""
                  className="w-3.5 h-3.5 rounded-sm"
                  onError={(e) => {
                    e.currentTarget.style.display = "none"
                  }}
                />
              )}
              <span>{link.display_name || link.name}</span>
              <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-70 transition-opacity" />
            </button>
          ))}
        </div>
      </div>
    </footer>
  )
}
